var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"token-login-page",attrs:{"element-loading-text":"正在登录…"}},[_c('div',{staticClass:"token-login-inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }